module.exports = __webpack_public_path__ + "img/IM.e53ca9c7.png";